import _ from 'lodash';
import store from '../store';

const md5 = require('js-md5');

const ACTIVE = 1;
const PENDING = 2;
const COMPLETED = 3;
const CANCELED = 4;
const utils = {};

utils.setCookie = (name, value, expY, expM, expD, path, domain, secure) => {
  let cookieString = `${name}=${encodeURI(value)}`;

  if (expY) {
    const expires = new Date(expY, expM, expD);
    cookieString += `; expires=${expires.toGMTString()}`;
  }

  if (path) { cookieString += `; path=${encodeURI(path)}`; }

  if (domain) { cookieString += `; domain=${encodeURI(domain)}`; }

  if (secure) { cookieString += '; secure'; }
  console.log('*************', cookieString);
  document.cookie = cookieString;
};

utils.deleteCookie = (cookieName) => {
  const cookieDate = new Date();
  cookieDate.setTime(cookieDate.getTime() - 1);
  document.cookie = `${cookieName}=; expires=${cookieDate.toGMTString()}`;
};

utils.digest = file =>
  new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = function (event) {
      resolve(md5(event.target.result));
    };
    reader.readAsArrayBuffer(file);
  });

utils.no401 = (fCtx, f, ...arg) =>
  new Promise((resolve, reject) => {
    f.call(fCtx, ...arg)
      .then(res => resolve(res))
      .catch((err) => {
        if (err.status === 401) {
          store.dispatch('waitRefresh')
            .then((refresh) => {
              if (refresh) {
                f.call(fCtx, ...arg)
                  .then(res => resolve(res))
                  .catch(err3 => reject(err3));
              } else {
                store.dispatch('refreshUser')
                  .then(() => f.call(fCtx, ...arg))
                  .then(res => resolve(res))
                  .catch(err4 => reject(err4));
              }
            })
            .catch(err2 => reject(err2));
        } else {
          reject(err);
        }
      });
  });

utils.formatCase = (cas, state) => {
  const c = Object.assign({}, cas);
  c.type = 'cas';
  c.created = utils.id2date(c._id);
  if (c.medias && c.medias[0]) {
    const medias = c.medias.map(media => Object.assign({}, media, {
      local: !!state.offMedias[media.id],
      dND: !!(state.offMedias[media.id] && state.offMedias[media.id].dnd),
    }));
    c.medias = medias;
  }

  /**
   * status
   * canceled -- canceled = true
   * active -- has not completed work with date
   *  pending -- no works or has work without date
   *  completed -- has at least one work and all works are completed
   *
   *  activelate, activehot,activecold
   *
   */

  let completed = true;
  let active = false;
  let completeDate;
  let planDate;
  let msDate;
  let tasks = []; // TODO в базе сохраняется formated case -- исправить
  c.createdLabel = utils.id2dateString(c._id); // extract creating date from id
  if (!c.num) {
    fetch('/numerate', { headers: { authorization: state.user.access_token } });
  }
  c.label = `${c.num || '????'} от ${c.createdLabel}`;
  c.link = `/${c._id}`;
  c.works.forEach((item) => {
    item.msDate = Infinity;
    if (!item.completed) {
      completed = false;
      if (item.date) {
        msDate = new Date(item.date).setHours(12, 0, 0, 0);
        planDate = planDate && (planDate < msDate) ? planDate : msDate;
        active = true;
        item.msDate = msDate;
        tasks = [item.task]; // if date -- nearest task
      } else {
        tasks.push(item.task); // if no date -- all tasks
      }
    } else if (item.date) { // work completed
      msDate = new Date(item.date).setHours(12, 0, 0, 0);
      completeDate = completeDate && (completeDate > msDate) ? completeDate : msDate;
      item.msDate = msDate;
    }
  });
  if (c.canceled) {
    c.status = CANCELED;
  } else if (c.works.length === 0) {
    c.status = PENDING;
  } else {
    c.status = completed ? COMPLETED : (active ? ACTIVE : PENDING);
  }
  if (c.status === COMPLETED) {
    c.workDate = completeDate;
    c.statusLabel = 'Выполнено';
  }
  if (c.status === ACTIVE) {
    c.workDate = planDate;
    c.statusLabel = 'Запланировано';
    c.tasks = tasks[0];
  }
  if (c.status === CANCELED) {
    c.statusLabel = 'Отменено';
  }
  if (c.status === PENDING) {
    c.statusLabel = 'Отложено';
    c.tasks = tasks.join(', ');
  }

  return c;
};

utils.statusClass = (status, workday) => {
  // console.log('utils.statusClass', workday)
  if (status === CANCELED) {
    return 'panel-canceled'; // отмененные
  }
  if (!workday || workday === Infinity || status === PENDING) {
    return 'panel-pending'; // отложенные
  }
  if (status === COMPLETED) {
    return 'panel-positive'; // завершенные
  }
  if (status === ACTIVE) {
    const now = new Date();
    const today = now.setHours(12, 0, 0, 0);
    if (today > workday) {
      return 'panel-negative'; // просроченные
    } else if (today === workday) {
      return 'panel-warning'; // сегодня
    } else if (workday - today < (7 * 1000 * 60 * 60 * 24)) {
      return 'panel-primary'; // в течении недели
    }
    return 'panel-info'; // еще позже
  }
};

utils.statusIcon = (status) => {
  if (status === CANCELED) {
    return 'pan_tool'; // отмененные
  }
  if (status === PENDING) {
    return 'hourglass_empty'; // отложенные
  }
  if (status === COMPLETED) {
    return 'done'; // завершенные
  }
  if (status === ACTIVE) {
    return 'build'; // в работе
  }
};


utils.s2a = (s) => {
  try {
    return Array.from(s);
  } catch (e) {
    return [];
  }
};

utils.o2a = (o) => {
  try {
    return Object.keys(o);
  } catch (e) {
    return [];
  }
};

utils.ov2a = (o) => {
  try {
    return Object.values(o);
  } catch (e) {
    return [];
  }
};

utils.isFormsValid = (forms) => {
  let result;
  if (_.isEmpty(forms)) {
    return true;
  }
  if (Array.isArray(forms)) {
    result = forms.every(f => utils.isFormsValid(f));
  } else {
    forms.validate((valid) => {
      result = valid;
    });
  }
  return result;
};

utils.id2date = (id) => {
  const s = id.slice(id.indexOf(':') + 1, -16);
  if (!s) {
    throw Error('Неверный id');
  } else {
    return new Date(parseInt(s, 16) * 1000);
  }
};

utils.id2dateString = (id) => {
  const s = id.slice(id.indexOf(':') + 1, -16);
  if (!s) {
    throw Error('Неверный id');
  } else {
    return new Date(parseInt(s, 16) * 1000).toLocaleDateString('ru');
  }
};

utils.isEmptyObject = o => Object.keys(o).length === 0;

utils.isTel = str => /^\+?[ \d_()-]+$/ig.test(str.trim()); // phone number

utils.isEmail = str => str.indexOf('@') > -1; // maybe email

utils.normalizeStr = (str) => {
  if (utils.isTel(str)) {
    return str.replace(/[^+\d]/g, ''); // remove all but plus sign and digits
  }
  return str.trim().toLowerCase();
};

utils.termInStr = (str, term) => {
  const termArr = term.split(/\s+/);
  let result = false;
  termArr.forEach((t) => {
    if (str.includes(t)) {
      result = true;
    }
  });
  return result;
};

utils.addLink = (str, term) => { // if term is set need highlight
  const normStr = utils.normalizeStr(str);
  const highStr = term && utils.termInStr(normStr, term) ? `<span class="highlight">${str}</span>` : str;
  if (utils.isEmail(str)) { // email
    return `<a href="mailto:${normStr}" onclick="event.stopPropagation()">${highStr}</a>`;
  } else if (utils.isTel(str)) { // phone number
    return `<a href="tel:${normStr}" onclick="event.stopPropagation()">${highStr}</a>`;
  }
  return str;
};

utils.telStringLinks = (telephones, term) => { // if term is set need highlight
  if (Array.isArray(telephones)) {
    const ar = telephones.map(tel => utils.addLink(tel, term));
    return ar.join(', ');
  }
  return '';
};

utils.searchTel = (telephones) => {
  if (telephones && telephones[0]) {
    const ar = telephones.map(tel => utils.normalizeStr(tel));
    return ar.join(' ');
  }
  return null;
};

utils.calcParents = (wikis) => {
  const output = {};
  Object.entries(wikis).forEach((item) => {
    const key = item[0];
    const value = item[1];
    const version = value.version;
    const pid = value.parent_id;
    const label = value.title;
    const hasVariant = value.hasVariant || false;
    const order = value.order || 0;
    const child = {
      key, label, version, hasVariant, order,
    };
    if (Array.isArray(output[pid])) {
      output[pid].push(child);
    } else {
      output[pid] = [child];
    }
    // .sort((a, b) => a.abbr.localeCompare(b.abbr));
    Object.values(output).forEach((c) => {
      c.sort((a, b) => {
        if (a.order === b.order) {
          return a.label.localeCompare(b.label);
        }
        return b.order - a.order;
      });
    });
  });
  return output;
};

utils.getId = (source, start = 0, end) => {
  if (source && source._id) {
    source = source._id;
  }
  if (!source || typeof source !== 'string') return null;
  if (!end) end = start + 1;
  return source.split(':').slice(start, end).join(':');
};

utils.icon = (id) => {
  if (!id || !id[0]) return 'delete';
  if (id[0] === 'i') return 'icon-instrument';
  else if (id[0] === 'p') return 'fa-user';
  else if (id[0] === 'd') return 'fa-sitemap';
  else if (id[0] === 'h') return 'fa-building';
  else if (id[0] === 'c') return 'fa-briefcase';
  return null;
};

utils.contentIcon = (contentType) => {
  const t = contentType.split('/')[0];
  if (!t) return '';
  if (t === 'image') {
    return 'photo_camera';
  } else if (t === 'video') {
    return 'videocam';
  } else if (t === 'audio') {
    return 'mic';
  } else if (t === 'geo') {
    return 'location_on';
  }
  return 'insert_drive_file';
};

utils.formatSize = (value) => {
  const units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB'];
  if (!value) return '';
  let bytes = parseInt(value, 10);
  if (Number.isNaN(bytes)) return '';
  let u = 0;
  while (Math.abs(bytes) >= 1024 && u < units.length - 1) {
    bytes /= 1024;
    u += 1;
  }
  return (bytes < 10 ? bytes.toFixed(1) : bytes.toFixed(0)) + units[u];
};

export default utils;



// WEBPACK FOOTER //
// ./src/others/utils.js